module.exports = __webpack_public_path__ + "static/media/avatar-header.7e375af9.svg";